import React from 'react';
import { observer } from 'mobx-react-lite';

import { getRenderedTime } from '../../../lib/utils/Convertor';
import { minutesFormatter } from '../../../lib/time-formatters';
import { BaseBlock } from './styled-strips';
import { Step } from '../../../app/entities/step';

import type { DayBreakStripProps } from './day-break-strip';
import { MobileDayStartStrip } from './day-start-strip.mobile';
import { useCurrentStep } from '../../../hooks/use-current-step';

import styles from './day-break-strip.mobile.module.scss';
export const MobileDayBreakStrip: React.FC<DayBreakStripProps> = observer(
  ({ isShotList, stripboard, strip }) => {
    const { dod, stepId, endTime, totalEstimatedTime, totalShotsDuration } = strip.data || {};

    const step = useCurrentStep();

    const shootingDay = Step.getOne(stepId)!;
    const totalShootingDays = stripboard.totalShootingDays;

    if (!shootingDay) {
      return null;
    }

    const renderedEndTime = !isShotList && getRenderedTime(endTime);

    const nextShootingDayStrip =
      totalShootingDays > 0 &&
      dod !== undefined &&
      dod < totalShootingDays &&
      strip.position !== undefined &&
      step?.type !== 'shootingDay'
        ? stripboard.getNextShootingDay(strip._id)
        : undefined;

    return (
      <>
        <div className={styles['container']}>
          <BaseBlock className={styles['end-of-day']}>
            {renderedEndTime ? `End of day ${dod} at ${renderedEndTime}` : `End of day ${dod}`}
          </BaseBlock>

          <div className={styles['time-container']}>
            <span>Total</span>

            {isShotList ? (
              <span>{minutesFormatter(totalShotsDuration)}</span>
            ) : (
              <span>{minutesFormatter(totalEstimatedTime)}</span>
            )}
          </div>
        </div>

        {nextShootingDayStrip && (
          <MobileDayStartStrip stripboard={stripboard} strip={nextShootingDayStrip} />
        )}
      </>
    );
  },
);
